import { useRef } from 'react';
import { useElements } from '@stripe/react-stripe-js';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Modal from '@sdk/components/ui/modal/Modal';
import ModalFooterActionButtons from '@sdk/components/ui/modal/ModalFooterActionButtons';
import ModalBodyWithHeader from '@sdk/components/ui/modal/ModalBodyWithHeader';

import { useStripeUtils } from '@web/account/hooks/stripeUtils.hooks';
import CreditCardForm from '@web/account/purchase/CreditCardForm/CreditCardForm';
import DashboardBlueSvg from '@web/assets/svg/Icons/32/dashboard-blue.svg';

type Props = {
  isVisible: boolean;
  accept: (result: any | undefined) => void;
  decline: () => void;
};

const CreditCardModal = ({ isVisible, accept, decline }: Props) => {
  const config = useRef({ noDismiss: true }).current;
  const elements = useElements();
  const { createPaymentMethod } = useStripeUtils();

  const onSubmit = async () => {
    const newPaymentMethodId = await createPaymentMethod(elements);

    accept(newPaymentMethodId);
  };

  return (
    <Modal fixed config={config} isVisible={isVisible}>
      <ModalBodyWithHeader
        width={620}
        titleThemeColor={ThemeColorType.primary}
        titleText={gettext('Use a different credit card')}
        titleIcon={<DashboardBlueSvg />}
        hideClose>
        <CreditCardForm />
        <ModalFooterActionButtons
          mTop={20}
          cancel={decline}
          submit={onSubmit}
          allowSubmitCallbackIfInactive
          cancelText={gettext('Use existing credit card')}
          submitText={gettext('Update credit card')}
        />
      </ModalBodyWithHeader>
    </Modal>
  );
};

export default CreditCardModal;
